import React from "react";
import SettingsHeroStat from "./SettingsHeroStat";

const TAB_BTN_BASE =
  "px-4 py-2 rounded-lg text-sm font-inter font-semibold whitespace-nowrap transition-all duration-150 touch-manipulation active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-blue/40 focus-visible:ring-offset-2 focus-visible:ring-offset-white";

export default function SettingsShell({
  user,
  tabs,
  activeTab,
  onTabChange,
  children,
}) {
  return (
    <div
      className="relative w-full h-full flex flex-col border-l overflow-y-auto"
      style={{
        background:
          "radial-gradient(ellipse at top left, #dbeafe 0%, transparent 50%), radial-gradient(ellipse at top right, #e0e7ff 0%, transparent 50%), radial-gradient(ellipse at bottom center, #eff6ff 0%, transparent 60%), #f8faff",
      }}
    >
      <div className="w-full flex flex-col px-4 md:px-8 pt-6 md:pt-8 pb-16 gap-6">
        <div className="rounded-[28px] border border-blue-100/80 bg-white/85 backdrop-blur-sm shadow-[0_18px_45px_rgba(15,23,42,0.06)] overflow-hidden">
          <div
            className="px-6 md:px-8 py-7 md:py-8"
            style={{
              background:
                "linear-gradient(135deg, rgba(255,255,255,0.98) 0%, rgba(239,246,255,0.95) 52%, rgba(224,231,255,0.82) 100%)",
            }}
          >
            <div className="flex flex-col gap-6">
              <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
                <div className="max-w-2xl">
                  <p className="font-inter text-xs font-semibold uppercase tracking-[0.25em] text-blue-600">
                    Workspace Preferences
                  </p>
                  <h1 className="mt-2 font-SFPro font-bold text-3xl text-gray-900">
                    Settings
                  </h1>
                  <p className="mt-2 text-sm font-inter leading-relaxed text-gray-600">
                    Manage your account details, administrative access, and outbound
                    email delivery configuration from one place.
                  </p>
                </div>
                <div className="grid grid-cols-2 gap-3 sm:flex sm:flex-wrap">
                  <SettingsHeroStat label="User" value={user?.username || "—"} />
                  <SettingsHeroStat
                    label="Role"
                    value={
                      user?.is_prime_superuser
                        ? "Prime Superuser"
                        : user?.is_staff || user?.is_superuser
                          ? "Administrator"
                          : "Standard User"
                    }
                  />
                </div>
              </div>

              <div
                className="inline-flex w-full md:w-fit items-center gap-2 rounded-2xl p-1.5 bg-white/80 border border-blue-100/80 shadow-sm overflow-x-auto"
                role="tablist"
                aria-label="Settings sections"
              >
                {tabs.map((tab) => (
                  <button
                    key={tab.key}
                    type="button"
                    role="tab"
                    aria-selected={activeTab === tab.key}
                    onClick={() => onTabChange(tab.key)}
                    className={`${TAB_BTN_BASE} ${
                      activeTab === tab.key
                        ? "bg-gradient-to-r from-primary-blue to-blue-400 text-white shadow-sm hover:from-blue-600 hover:to-blue-500"
                        : "text-gray-600 hover:bg-blue-50 hover:text-gray-900"
                    }`}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>

        {children}
      </div>
    </div>
  );
}
